import React, { useState, useEffect } from "react";
import "./myPatientsViewRightContainer.scss";
import { Divider } from "@material-ui/core";
import editIcon from "../../../assets/edit_icon.svg";
import closeIcon from "../../../assets/forhomepage/close_icon.svg";
import moment from "moment";
import AddIcon from "../../../assets/add_icon.png";
import DatePicker from "../../common/DatePicker/DatePicker";
import {
  UPDATE_PATIENT_INFO,
  UPDATE_PATIENT_ADDRESS_INFO,
  GET_STATE_CITY,
  GET_UHID_LIST,
} from "../MyPatientsViewAppointmentsApiHandler/apiConstants";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import {
  c2cGetApiHandler,
  c2cPostApiHandler,
} from "../../../Util/c2cApiHandler";
import {
  UHID_DUPLICATE_ERROR,
  UHID_SINGLE_QUOTES_ERROR,
  getUHIDFormatError,
} from "../constants";

const MyPatientsViewRightContainer = (props) => {
  const { patientInfo, upcomingAppointment, getPatientInfo, setPatientInfo } =
    props;

  const pinCodeRegex = /^[1-9]\d{5}$/;
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const user_type = localStorage.getItem("user_type");
  const clinic_name = localStorage.getItem("clinicName");
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  const [editName, setEditName] = useState(false);
  const [patientName, setPatientName] = useState(null);
  const [editDob, setEditDob] = useState(false);
  const [patientDob, setPatientDob] = useState("");
  const [showEditPincode, setShowEditPincode] = useState(false);
  const [showEditAddress, setShowEditAddress] = useState(false);
  const [pincodeError, setPincodeError] = useState(false);
  const [pinCode, setPinCode] = useState("");
  const [patientAddress, setPatientAddress] = useState("");
  const [patientCity, setPatientCity] = useState("");
  const [patientState, setPatientState] = useState("");
  const [patientStateCode, setPatientStateCode] = useState("");
  const [showEditUhid, setShowEditUhid] = useState(false);
  const [uhidInput, setUhidInput] = useState("");
  const [isUHidEnabled, setIsUHidEnabled] = useState(false);
  const [uhIdList, setUHIdList] = useState([]);
  const [uhidPrefix, setUHIdPrefix] = useState("");
  const [uhidError, setUhidError] = useState("");

  const inputHolderClassName = pincodeError
    ? "mypatient-pincode-input-holder-error"
    : "mypatient-pincode-input-holder";

  useEffect(() => {
    setPinCode(patientInfo?.patient_pincode);
    setPatientCity(patientInfo?.city_name);
    setPatientState(patientInfo?.patient_state_name);
    setPatientStateCode(patientInfo?.patient_pincode);
    setPatientAddress(patientInfo?.patient_address);
    setUhidInput(patientInfo?.formatted_uhid);
  }, [patientInfo]);

  useEffect(() => {
    if (clinicId) {
      getClinicUhidListApiCall();
    }
  }, []);
  // Actions ===>

  const handleDateChange = (date) => {
    setPatientDob(date === "" ? "" : moment(date).format("yyyy-MM-DD"));
  };

  const onPinCodeEdit = () => {
    setShowEditPincode(true);
    setPincodeError(false);
  };

  const onPinCodeSave = () => {
    if (patientState && patientCity && !pincodeError) {
      updatePatientAddressInfo();
      setShowEditPincode(false);
      setPincodeError(false);
    }
  };

  const onPinCodeCancel = () => {
    setShowEditPincode(false);
    setPincodeError(false);
    getStateCity(patientInfo?.patient_pincode);
    setPinCode(patientInfo?.patient_pincode);
  };

  const onAddressEdit = () => {
    setShowEditAddress(true);
    setPatientAddress(patientInfo?.patient_address);
  };

  const onAddressSave = () => {
    if (patientState && patientCity) {
      updatePatientAddressInfo();
      setShowEditAddress(false);
    }
  };

  const onAddressCancel = () => {
    setShowEditAddress(false);
    setPatientAddress(patientInfo?.patient_address);
  };

  const handleOnChange = (event) => {
    let pinCodeValue = event.target.value;
    if (pinCodeValue?.length <= 6) {
      setPinCode(event.target.value);
      if (!pinCodeRegex.test(pinCodeValue)) {
        setPincodeError(true);
      } else {
        getStateCity(pinCodeValue);
      }
    }
  };

  const handleNumericInput = (e) => {
    if (e.key > 47 && e.key < 58) {
      e.preventDefault();
    }
  };

  const handleOnAddressChange = (event) => {
    setPatientAddress(event.target.value);
  };

  const handleEditUhid = () => {
    setUhidInput(patientInfo?.formatted_uhid);
    setShowEditUhid(true);
  };

  const handleUhidInput = (e) => {
    let enteredVal = e.target.value;
    setUhidInput(enteredVal);
    let regEx = /^[A-Za-z]+[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{0,1}[/d]+$/;
    let single_double_quote_regex = /['||"]/;
    let newArr = uhIdList?.length > 0 ? [...uhIdList] : [];
    if (enteredVal.length > 0) {
      if (
        patientInfo?.formatted_uhid?.toLowerCase()?.trim() ===
        enteredVal?.toLowerCase()?.trim()
      ) {
        setUhidError("");
      } else {
        if (single_double_quote_regex.test(enteredVal)) {
          setUhidError(UHID_SINGLE_QUOTES_ERROR);
        } else {
          if (uhidPrefix) {
            if (regEx.test(enteredVal)) {
              let word = e.target.value.match(/\D+/g);
              let digits = e.target.value.match(/\d+/g);
              if (word.length > 0) {
                if (word[0]?.toLowerCase() === uhidPrefix?.toLowerCase()) {
                  if (digits.length > 0) {
                    if (newArr?.length > 0) {
                      let index = newArr.findIndex(
                        (d) => d.uhid_no === Number(digits[0])
                      );
                      if (index > -1) {
                        setUhidError(UHID_DUPLICATE_ERROR);
                      } else {
                        setUhidError("");
                      }
                    } else {
                      setUhidError("");
                    }
                  }
                } else {
                  setUhidError(getUHIDFormatError(uhidPrefix));
                }
              }
            } else {
              setUhidError(getUHIDFormatError(uhidPrefix));
            }
          } else {
            let duplicateUHID = newArr.filter(
              (existingUHID) =>
                existingUHID?.formatted_uhid?.toLowerCase()?.trim() ===
                enteredVal?.toLowerCase()?.trim()
            );
            if (duplicateUHID?.length > 0) {
              setUhidError(UHID_DUPLICATE_ERROR);
            } else {
              setUhidError("");
            }
          }
        }
      }
    } else {
      setUhidError("");
    }
  };

  const handleCloseUhidEdit = () => {
    setUhidError("");
    setShowEditUhid(false);
    setUhidInput(patientInfo?.formatted_uhid);
  };

  // <===

  // Api calls ===>

  const updatePatientInfo = () => {
    let reqPayload = {
      user_id: user_type === "staff" ? staffId : userId,
      user_type: user_type,
      patient_account_id: patientInfo?.patient_account_id,
      patient_id: patientInfo?.patient_id,
      patient_dob: patientDob ? patientDob : patientInfo?.patient_dob,
      patient_email: patientInfo?.email,
      patient_gender: patientInfo?.patient_gender,
      patient_name: patientName?.trim()
        ? patientName
        : patientInfo?.patient_name,
      formatted_uhid: uhidInput?.trim()?.toUpperCase(),
    };
    const data = c2cPostApiHandler(UPDATE_PATIENT_INFO, reqPayload);
    data.then(([res, error]) => {
      if (res?.data?.statusCode === 200) {
        setEditName(false);
        setShowEditUhid(false);
        getPatientInfo();
        if (clinicId && isUHidEnabled) {
          getClinicUhidListApiCall();
        }
      }
    });
  };

  const getStateCity = (patientPincode) => {
    let payload = {
      pincode: patientPincode,
    };
    const data = c2cPostApiHandler(GET_STATE_CITY, payload);
    data.then(([response, error]) => {
      if (response?.data?.statusCode == 200) {
        console.log("response--->", response);
        setPatientCity(response?.data?.data?.city_name);
        setPatientState(response?.data?.data?.state_name);
        setPatientStateCode(response?.data?.data?.state_code);
        setPincodeError(false);
      } else {
        setPincodeError(true);
        setPatientCity(null);
        setPatientState(null);
        setPatientStateCode(null);
      }
    });
  };

  const updatePatientAddressInfo = () => {
    let reqPayload = {
      patient_pincode: pinCode ? pinCode : patientInfo?.patient_pincode,
      patient_city: patientCity ? patientCity : patientInfo?.city_name,
      patient_state: patientState
        ? patientState
        : patientInfo?.patient_state_name,
      state_code: patientStateCode ? patientStateCode : patientInfo?.state_code,
      patient_address: patientAddress
        ? patientAddress
        : patientInfo?.patient_address,
      patient_account_id: patientInfo?.patient_account_id,
    };
    let tempPatientInfo = { ...patientInfo };
    setPatientInfo({
      ...tempPatientInfo,
      patient_pincode: pinCode,
      patient_address: patientAddress,
      city_name: patientCity,
      patient_state_name: patientState,
    });
    const data = c2cPostApiHandler(UPDATE_PATIENT_ADDRESS_INFO, reqPayload);
    data.then(([res, error]) => {
      if (res?.data?.statusCode === 200) {
        getPatientInfo();
      }
    });
  };

  const getClinicUhidListApiCall = () => {
    const uhIdResponse = c2cGetApiHandler(GET_UHID_LIST(clinicId));
    uhIdResponse.then(([res, error]) => {
      if (!error) {
        if (res.data.patient_uhid_enabled) {
          if (res.data.existing_patient_uhids?.length > 0) {
            res.data.existing_patient_uhids.forEach((d) => {
              let word = d.formatted_uhid.match(/\D+/g);
              let digits = d.formatted_uhid.match(/\d+/g);
              d["uhid_prefix"] = word?.length > 0 ? word[0] : "";
              d["uhid_no"] = digits?.length > 0 ? Number(digits[0]) : "";
            });
          }
          setUHIdPrefix(res?.data?.patient_uhid_prefix?.trim());
          setUHIdList(res?.data.existing_patient_uhids);
        } else {
          setUHIdList([]);
        }
        setIsUHidEnabled(res.data.patient_uhid_enabled);
      }
    });
  };

  // <===

  // Display UI ===>

  const displayMyPatientsViewRightContainer = () => {
    return (
      <div className="mypatients-view-right-container">
        {displayUpcommingAppointments()}
        {clinicId && displayClinicName()}
        {displayPatientDetails()}
      </div>
    );
  };

  const displayUpcommingAppointments = () => {
    return (
      <div className="mypatients-right-cont-components">
        <div className="mypatients-right-cont-components-title">
          Upcoming Appointment
        </div>
        <Divider className="mypatients-right-cont-components-divider" />
        {upcomingAppointment?.appointment_date ? (
          <div className="mypatients-right-cont-components-content d-flex ai-center">
            <div className="upcomming-appointment-date">
              <div className="upcomming-appointment-date-month">
                {moment(upcomingAppointment.appointment_date).format("MMM")}
              </div>
              <div className="upcomming-appointment-date-value">
                {moment(upcomingAppointment.appointment_date).format("DD")}
              </div>
            </div>
            <div className="upcomming-appointment-timing">
              <div className="upcomming-appointment-timing-title">Timing</div>
              <div className="upcomming-appointment-timing-value">
                {moment(upcomingAppointment.appointment_date).format("ddd")},{" "}
                {moment(
                  upcomingAppointment.appointment_date +
                    "T" +
                    upcomingAppointment.start_time
                ).format("hh:mm A")}
                {" - "}
                {moment(
                  upcomingAppointment.appointment_date +
                    "T" +
                    upcomingAppointment.end_time
                ).format("hh:mm A")}
              </div>
            </div>
          </div>
        ) : (
          <div className="mypatient-no-upcoming-appointment">
            No upcoming appointment
          </div>
        )}
      </div>
    );
  };

  const displayClinicName = () => {
    return (
      <div className="mypatients-right-cont-components">
        <div className="mypatients-right-cont-components-title">
          Clinic Name
        </div>
        <Divider className="mypatients-right-cont-components-divider" />
        <div className="mypatients-right-cont-components-content mypatients-right-cont-clinic-name">
          {clinic_name}
        </div>
      </div>
    );
  };

  const displayPatientDetails = () => {
    return (
      <div className="mypatients-right-cont-components">
        <div className="mypatients-right-cont-components-title">
          Personal Details
        </div>
        <Divider className="mypatients-right-cont-components-divider" />
        <div
          className="mypatients-right-cont-components-content"
          style={{ paddingRight: "20px" }}
        >
          {displayFullName()}
          {displayGenderAndUHid()}
          {displayContactNumber()}
          {displayDOB()}
          {displayEmailAndAddress()}
          {displayAddressUI()}
        </div>
      </div>
    );
  };

  const displayFullName = () => {
    return (
      <div
        className="mypatients-right-cont-components-fullname"
        style={{ display: !editName ? "flex" : "" }}
      >
        <div style={{ flex: !editName ? "1" : "" }}>
          <div className="mypatients-components-header">Full Name</div>
          {!editName ? (
            <div
              className="mypatients-components-value"
              style={{ textTransform: "capitalize" }}
            >
              {patientInfo.patient_name}
            </div>
          ) : (
            <div className="mr-2 mb-4">
              <div className="input-holder">
                <input
                  type="text"
                  className="search-input"
                  onChange={(e) => setPatientName(e.target.value)}
                  value={patientName}
                  onKeyDown={handleNumericInput}
                />
                <div className="close_search">
                  <img
                    src={closeIcon}
                    alt="close_icon"
                    onClick={() => {
                      setEditName(false);
                      setPatientName(patientInfo?.patient_name);
                    }}
                  />
                </div>
              </div>
              <span className="mt-1 note">
                Note: Patient name will not be updated in past completed records
              </span>
              <div
                style={{
                  marginTop: "5px",
                  borderTop: "1px dashed #D6DAE5",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <div className="mt-2">
                  <button
                    type="button"
                    className="btn btn-link apply"
                    onClick={() => {
                      setEditName(false);
                      setPatientName(patientInfo?.patient_name);
                    }}
                    style={{ color: "#17BAE0", fontSize: "14px" }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    style={{ height: "35px" }}
                    onClick={() =>
                      patientName.trim() !== "" ? updatePatientInfo() : ""
                    }
                    className="btn btn-sm primary-cta-button rounded-pill py-2 px-1"
                    disabled={patientName?.trim() === ""}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {!editName && (
          <div
            onClick={() => {
              setPatientName(patientInfo?.patient_name);
              setEditName(true);
            }}
          >
            <img src={editIcon} alt="" style={{ cursor: "pointer" }} />
          </div>
        )}
      </div>
    );
  };

  const displayGenderAndUHid = () => {
    return (
      <div className="d-flex justify-content-between">
        {(patientInfo?.formatted_uhid || isUHidEnabled) && (
          <div className="mr-1">
            <div className="mypatients-components-header">
              UHID
              {patientInfo?.manual_uhid?.toLowerCase() === "true" &&
                isUHidEnabled &&
                !showEditUhid && (
                  <img
                    onClick={handleEditUhid}
                    className="mypatient-address-edit-icon"
                    src={editIcon}
                    alt="#"
                  />
                )}
            </div>
            {showEditUhid ? (
              <div className="mr-2 mb-4">
                <div className="input-holder">
                  <input
                    type="text"
                    className="search-input"
                    onChange={handleUhidInput}
                    value={uhidInput}
                  />
                  <div className="close_search">
                    <img
                      src={closeIcon}
                      alt="close_icon"
                      onClick={handleCloseUhidEdit}
                    />
                  </div>
                </div>
                <div className="uhid-btn-container">
                  <div className="mt-2">
                    <button
                      type="button"
                      className="btn btn-link apply uhid-cancel-btn"
                      onClick={handleCloseUhidEdit}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => !uhidError?.trim() && updatePatientInfo()}
                      className="btn btn-sm primary-cta-button rounded-pill py-2 px-1 uhid-save-btn"
                      disabled={uhidError?.trim()}
                    >
                      Save
                    </button>
                  </div>
                </div>
                {uhidError?.trim() && <p className=" error">{uhidError}</p>}
              </div>
            ) : (
              <div className="mypatients-components-value">
                {uhidInput ? uhidInput : "-"}
              </div>
            )}
          </div>
        )}
        <div>
          <div className="mypatients-components-header">Gender</div>
          <div className="mypatients-components-value">
            {patientInfo.patient_gender}
          </div>
        </div>
      </div>
    );
  };

  const displayDOB = () => {
    return (
      <div className="mypatients-right-cont-components-dob">
        <div>
          <div className="mypatients-components-header">Date of Birth</div>
          {patientInfo?.patient_dob !== "" ? (
            <div className="mypatients-components-value">
              {moment(patientInfo.patient_dob).format("DD MMM YYYY")}
            </div>
          ) : (
            displayAddDOB()
          )}
        </div>
      </div>
    );
  };

  const displayAddDOB = () => {
    return (
      <>
        {!editDob ? (
          <div style={{ marginBottom: "20px" }}>
            <img src={AddIcon} alt="add" height="20px" width="20px" />
            <button
              type="button"
              className="btn btn-link apply pl-1"
              onClick={() => {
                setEditDob(true);
              }}
              style={{ color: "#17BAE0", fontSize: "14px" }}
            >
              Add Date of Birth
            </button>
          </div>
        ) : (
          <div style={{ marginBottom: "20px" }}>
            <DatePicker
              selectorDate={patientDob}
              handleDateChange={handleDateChange}
              message="Note: DOB cannot be edited once saved"
            />
            <div
              style={{
                marginTop: "5px",
                borderTop: "1px dashed #D6DAE5",
                display: "flex",
                justifyContent: "end",
              }}
            >
              <div className="mt-2">
                <button
                  type="button"
                  className="btn btn-link apply"
                  onClick={() => {
                    setEditDob(false);
                    setPatientDob("");
                  }}
                  style={{ color: "#17BAE0", fontSize: "14px" }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  style={{ height: "35px" }}
                  onClick={updatePatientInfo}
                  className="btn btn-sm primary-cta-button rounded-pill py-2 px-1"
                  disabled={patientDob === ""}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const displayEmailAndAddress = () => {
    return (
      <div>
        <div>
          <div className="mypatients-components-header">Email ID</div>
          <div className="mypatients-components-value">
            {patientInfo.email ? patientInfo.email : "-"}
          </div>
        </div>
        <div></div>
      </div>
    );
  };

  const displayAddressUI = () => {
    return (
      <div className="patient-address-container">
        <div className="mypatient-pincode-editicon-wrapper">
          <div className="mypatients-components-header">Pincode</div>
          {!showEditPincode && (
            <img
              onClick={onPinCodeEdit}
              className="mypatient-address-edit-icon"
              src={editIcon}
              alt="#"
            />
          )}
        </div>
        {showEditPincode ? (
          <div className="mypatient-pincode-input-and-error-wrapper">
            <div className="mypatient-edit-input-and-btns-wrapper">
              <div className={inputHolderClassName}>
                <input
                  className="mypatient-pincode-input"
                  maxLength="6"
                  value={pinCode}
                  type="number"
                  onKeyDown={(e) =>
                    (e.keyCode === 69 ||
                      e.keyCode === 187 ||
                      e.keyCode === 61 ||
                      e.keyCode === 190 ||
                      e.keyCode === 189) &&
                    e.preventDefault()
                  }
                  onChange={handleOnChange}
                />
              </div>
              <div className="mypatient-save-cancle-btns">
                <button
                  type="button"
                  className="mypatient-save-calcel-btn"
                  onClick={onPinCodeCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="mypatient-save-pincode-btn"
                  onClick={onPinCodeSave}
                >
                  Save
                </button>
              </div>
            </div>
            {pincodeError && (
              <p className=" error">Please enter valid pincode.</p>
            )}
          </div>
        ) : (
          <div className="mypatients-components-value">
            {patientInfo?.patient_pincode}
          </div>
        )}

        <div className="my-patient-state-city-wrapper">
          <div className="my-patient-address-city-wrapper">
            <div className="mypatients-components-header">City</div>
            <div className="mypatients-components-value">
              {!patientCity ? patientInfo?.city_name : patientCity}
            </div>
          </div>
          <div>
            <div className="mypatients-components-header">state</div>
            <div className="mypatients-components-value">
              {!patientState ? patientInfo?.patient_state_name : patientState}
            </div>
          </div>
        </div>
        <div className="mypatient-address-wrapper">
          <div className="mypatient-address-heading-edit-icon-wrapper">
            <div className="mypatients-components-header">Address</div>
            {!showEditAddress && (
              <img
                onClick={onAddressEdit}
                className="mypatient-address-edit-icon"
                src={editIcon}
                alt="#"
              />
            )}
          </div>
          {showEditAddress ? (
            <div className="mr-2 mb-4">
              <div className="mypatient-edit-address-input-wrapper">
                <textarea
                  type="text"
                  className="mypatient-address-edit-feild"
                  value={patientAddress}
                  onKeyDown={handleNumericInput}
                  onChange={handleOnAddressChange}
                ></textarea>
              </div>
              <div className="address-cancel-save-btn-wrapper">
                <div className="mt-2">
                  <button
                    type="button"
                    className="address-cancel-btn"
                    onClick={onAddressCancel}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={onAddressSave}
                    className="address-save-btn"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="mypatients-full-address">
              {patientInfo?.patient_address}
            </div>
          )}
        </div>
      </div>
    );
  };

  const displayContactNumber = () => {
    return (
      <div>
        <div className="mypatients-components-header">Mobile Number</div>
        <div className="mypatients-components-value">
          {patientInfo.patient_phone}
        </div>
      </div>
    );
  };

  // <===

  return <>{displayMyPatientsViewRightContainer()}</>;
};

export default MyPatientsViewRightContainer;
